import { Col, Divider, Row } from 'antd';
import { useDispatch } from 'react-redux';
import { IListColumn } from 'src/@types/search-params';
import CGridView from 'src/components/CGridView';
import TableContent from 'src/components/CTable';
import useWindowSize from 'src/hooks/useWindowSize';
import { useAppSelector } from 'src/redux/hook';
import { setPackageAssignedState } from 'src/redux/slice/packageAssigned';
import { OrderStatusEnum } from 'src/shared/enum/package_assigned';
import { IOverFlowOrderDetailResponse } from 'src/shared/interface/package_assigned';
import { formatMoney, renderSubType } from 'src/utils';

interface InputCorrect {
  dataSuccess: IOverFlowOrderDetailResponse[];
  statusSim: string;
  infoPackageInput: IOverFlowOrderDetailResponse | undefined;
}

function InputCorrect({ dataSuccess, statusSim, infoPackageInput }: InputCorrect) {
  const { order } = useAppSelector((state) => state.global);
  const dispatch = useDispatch();
  const size = useWindowSize();

  const columns: IListColumn[] = [
    { name: 'STT', fieldName: 'index', width: 20 },
    { name: 'SIM serial', fieldName: 'serial', isHideSort: true },
    {
      name: 'Mã gói',
      fieldName: 'mbfCode',
      isHideSort: true,
      renderSpecialCard: (item: IOverFlowOrderDetailResponse) => {
        return (
          <span>
            {item && item?.mbfCode
              ? item?.mbfCode
              : infoPackageInput && infoPackageInput?.mbfCode
              ? infoPackageInput?.mbfCode
              : ''}
          </span>
        );
      },
    },
    {
      name: 'Tên gói',
      fieldName: 'mbfName',
      isHideSort: true,
      renderSpecialCard: (item: IOverFlowOrderDetailResponse) => {
        return (
          <span>
            {item && item?.mbfName
              ? item?.mbfName
              : infoPackageInput && infoPackageInput?.mbfName
              ? infoPackageInput?.mbfName
              : ''}
          </span>
        );
      },
    },
    // {
    //   name: 'Loại thuê bao',
    //   fieldName: 'subType',
    //   isHideSort: true,
    //   renderSpecialCard: (record) => {
    //     return <p>{renderSubType(masterData, record?.subType)}</p>;
    //   },
    // },
    {
      name: 'Thành tiền',
      fieldName: 'price',
      isHideSort: true,
      renderSpecialCard: (item: IOverFlowOrderDetailResponse) => {
        return (
          <span>
            {item.price
              ? formatMoney(item?.price, 'đ')
              : infoPackageInput && infoPackageInput?.price
              ? formatMoney(infoPackageInput?.price, 'đ')
              : ''}
          </span>
        );
      },
    },
    { name: 'Trạng thái', fieldName: 'statusString', isHideSort: true },
    { name: 'Mã lỗi', fieldName: 'errorCode', isHideSort: true },
    { name: 'Mô tả lỗi', fieldName: 'errorMessage', isHideSort: true },
    {
      name: 'Thao tác',
      renderSpecialCard: (item) => (
        <button
          className={`underline whitespace-nowrap bg-transparent border-transparent text-blue-500 font-semibold ${
            statusSim === OrderStatusEnum.EDIT || (statusSim === OrderStatusEnum.New && !order?.id)
              ? 'cursor-pointer'
              : 'opacity-30'
          }`}
          disabled={
            statusSim === OrderStatusEnum.EDIT || (statusSim === OrderStatusEnum.New && !order?.id)
              ? false
              : true
          }
          onClick={() => handleDeleteSim(item)}
        >
          Xóa
        </button>
      ),
      isHideSort: true,
    },
  ];

  const handleDeleteSim = (item: IOverFlowOrderDetailResponse) => {
    const filter = dataSuccess.filter((i) => i.serial !== item.serial);
    dispatch(setPackageAssignedState({ dataSuccess: filter ?? [] }));
  };

  return size.width < 1024 ? (
    <CGridView
      length={dataSuccess?.length}
      totalRecord={dataSuccess?.length ?? 0}
      columns={columns}
    >
      {dataSuccess && dataSuccess.length > 0 ? (
        dataSuccess.map((item: IOverFlowOrderDetailResponse) => {
          return (
            <div key={'data-row-' + item.id}>
              <Divider className='border-t-black' />

              <Row className='mb-6  items-center' gutter={[4, 16]}>
                {columns.map((ele) => {
                  if (ele.fieldName !== 'index' && ele.fieldName !== 'action') {
                    return (
                      <>
                        <Col span={11} className={`font-bold label`}>
                          <div className='flex gap-2 items-center'>{ele.name}</div>
                        </Col>
                        <Col className='break-words text-right' span={13}>
                          {ele?.renderSpecialCard
                            ? ele?.renderSpecialCard(item, null, null, null)
                            : item[`${ele?.fieldName}`]}
                        </Col>
                      </>
                    );
                  } else if (ele.fieldName === 'action') {
                    return (
                      <Col key={'column-' + item.id + ele.fieldName} span={24}>
                        <div className='flex gap-6'>
                          {ele?.renderSpecialCard
                            ? ele?.renderSpecialCard(item, null, null, null)
                            : item[`${ele?.fieldName}`]}
                        </div>
                      </Col>
                    );
                  } else {
                    return <></>;
                  }
                })}
              </Row>
            </div>
          );
        })
      ) : (
        <p>{'Không có dữ liệu'}</p>
      )}
    </CGridView>
  ) : (
    <TableContent
      bordered
      scroll={{ x: 'max-content' }}
      locale={{ emptyText: 'Không tìm thấy kết quả' }}
      dataSource={dataSuccess ?? []}
      columns={columns}
      isHidePaging={true}
    />
  );
}

export default InputCorrect;
